// extracted by mini-css-extract-plugin
export var actionButton = "_l1-t";
export var buttonContainer = "_l1-0";
export var buttonContainer2 = "_l1-1";
export var buttonSection = "_l1-2";
export var details = "_l1-3";
export var dropdownItem = "_l1-5";
export var dropdownItemsContainer = "_l1-4";
export var fileInput = "_l1-r";
export var headerButton = "_l1-6";
export var icon = "_l1-7";
export var input = "_l1-8";
export var macroListItem = "_l1-9";
export var mainContent = "_l1-a";
export var microText = "_l1-b";
export var modal = "_l1-w";
export var optionsButton = "_l1-c";
export var paperclip = "_l1-s";
export var pillContent = "_l1-d";
export var preview = "_l1-e";
export var preview2 = "_l1-f";
export var quillEditor = "_l1-q";
export var selectedMacro = "_l1-g";
export var sidebar = "_l1-h";
export var sidebarHeader = "_l1-j";
export var sidebarList = "_l1-i";
export var sidebarListItem = "_l1-k";
export var sidebarSearch = "_l1-l";
export var snoozeDurationWrapper = "_l1-v";
export var statusPillContainer = "_l1-m";
export var tagsContainer = "_l1-n";
export var unselectedMacro = "_l1-o";
export var variable = "_l1-u";
export var wrapper = "_l1-p";